import Page from '../../../shared/components/Page/Page';
import {Button, Form, Space, Table, Tag} from "antd";
import {useEffect, useState} from "react";
import {formatDateTime, numberFormat} from "../../../shared/utils/helpers";
import TextCopy from "../../../shared/components/TextCopy";
import Search from "../../../shared/components/Search/Search";
import { getPayOuts } from "../api";
import dayjs from "dayjs";
import {ExportOutlined} from "@ant-design/icons";
import ExportFile from "../../../shared/components/ExportFile/ExportFile";
import '../../../shared/styles/buttons.css';

function PayOut() {
    const [tableLoading,setTableLoading] = useState(false);
    const [form] = Form.useForm();
    const [dataSource,setDataSource] = useState([]);
    const [openExport, setOpenExport] = useState(false);
    const [summaryData, setSummaryData] = useState({
        totalAmount: 0,
        totalFee: 0,
        totalActualAmount: 0,
    });
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        search: {
            createdAt: [dayjs().startOf('day'), dayjs().endOf('day')]
        }
    });

    const items =  [
        {
            name: 'uuid',
            placeholder: 'Mã đơn',
            type: 'text'
        },
        {
            name: 'requestId',
            placeholder: 'Mã tra soát',
            type: 'text'
        },
        {
            name: 'nickname',
            placeholder: 'Nickname',
            type: 'text'
        },
        {
            name: 'accNo',
            placeholder: 'Số tài khoản',
            type: 'text'
        },
        {
            name: 'createdAt',
            placeholder: 'Thời gian',
            type: 'date'
        },
    ];

    const columns = [
        {
            title: 'ID',
            dataIndex: 'uuid',
            align: 'center',
            render: (value) => {
                return <TextCopy value={value}/>
            }
        },
        {
            title: 'Mã tra soát',
            dataIndex: 'requestId',
            align: 'center',
            render: (value) => {
                return <TextCopy value={value}/>
            }
        },
        {
            title: 'Nickname',
            dataIndex: 'nickname',
            width: '150px',
            align: 'center',
            render: (value) => {
                return <TextCopy value={value}/>
            }
        },
        {
            title: 'Ngân hàng',
            dataIndex: 'bankName',
            align: 'center'
        },
        {
            title: 'Số tài khoản',
            dataIndex: 'accNo',
            align: 'center',
            render: (value) => {
                return <TextCopy value={value}/>
            }
        },
        {
            title: 'Tên tài khoản',
            dataIndex: 'accName',
            align: 'center',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Số tiền',
            dataIndex: 'amount',
            align: 'center',
            sorter: true,
            render: (value) => {
                return numberFormat(value)
            }
        },
        {
            title: 'Phí',
            dataIndex: 'fee',
            align: 'center',
            render: (value) => {
                return numberFormat(value, 2)
            }
        },
        {
            title: 'Tiền trừ',
            dataIndex: 'actualAmount',
            align: 'center',
            sorter: true,
            render: (value) => {
                return numberFormat(value)
            }
        },
        {
            title: 'Nội dung',
            dataIndex: 'content',
            align: 'center'
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            align: 'center',
            filters: [
                {
                    text: 'Đã hoàn thành',
                    value: true
                },
                {
                    text: 'Chưa hoàn thành',
                    value: false
                }
            ],
            render: (value) => {
                if(value) {
                    return <Tag color={'green'}>Đã hoàn thành</Tag>
                }
                return <Tag color={'red'}>Chưa hoàn thành</Tag>
            }
        },
        {
            title: 'Tình trạng',
            dataIndex: 'statusCode',
            align: 'center',
            filters: [
                {
                    text: 'Thành công',
                    value: 0
                },
                {
                    text: 'Bị hủy',
                    value: -6
                },
                {
                    text: 'Sai tên',
                    value: -5
                }
            ],
            render: (value) => {
                if (value === 0) {
                    return <Tag color={'green'}>Thành công</Tag>
                }else if (value === 1) {
                    return <Tag color={'yellow'}>Đang chờ</Tag>
                }else if(value === 2) {
                    return <Tag color={'blue'}>Kiểm tra tên</Tag>
                }else if (value === 3) {
                    return <Tag color={'blue'}>Tạo lệnh</Tag>
                }else if (value === 4) {
                    return <Tag color={'blue'}>Duyệt lệnh</Tag>
                }else if (value === -5) {
                    return <Tag color={'red'}>Tên không khớp</Tag>
                }
            }
        },
        {
            title: 'Trạng thái CB',
            dataIndex: 'isCallback',
            align: 'center',
            filters: [
                {
                    text: 'Đã callback',
                    value: true
                },
                {
                    text: 'Chưa callback',
                    value: false
                },
            ],
            render: (value) => {
                if (value) {
                    return <Tag color={'success'}>Đã CALLBACK</Tag>
                }
                return <Tag color={'yellow'}>Chưa CALLBACK</Tag>
            }
        },
        {
            title: 'Hoàn tiền',
            dataIndex: 'isRefunded',
            align: 'center',
            render: (value) => {
                if (value) {
                    return <Tag color={'success'}>Đã hoàn</Tag>
                }
            }
        },
        {
            title: 'Thời gian tạo',
            dataIndex: 'createdAt',
            sorter: true,
            align: 'center',
            width: '180px',
            render: (value,record)  => {
                return (
                    <Tag>{formatDateTime(value)}</Tag>
                )
            }
        },
        {
            title: 'Thời gian hoàn thành',
            dataIndex: 'completedAt',
            sorter: true,
            align: 'center',
            width: '180px',
            render: (value,record)  => {
                if (value) {
                    return (
                        <Tag>{formatDateTime(value)}</Tag>
                    )
                }
            }
        },
        {
            title: 'Địa chỉ IP',
            dataIndex: 'ipAddress',
            align: 'center',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Hành động',
            dataIndex: 'operation',
            align: 'center',
            render: (_,record) => {
                return (
                    <Space>
                    </Space>
                )
            }
        }
    ];

    const handleSearch = () => {
        const params = form.getFieldsValue();
        setTableParams({
            ...tableParams,
            search: {
                ...params
            }
        })
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            ...tableParams,
            pagination,
            filters,
            sorter,
        });
    };

    const fetchDataPayOuts = async () => {
        setTableLoading(true);
        const response = await getPayOuts( tableParams);
        if (response.success) {
            setDataSource(response.data.data);
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    total: response.data.total
                },
            });
            setSummaryData({
                totalAmount: response.data.totalAmount,
                totalFee: response.data.totalFee,
                totalActualAmount: response.data.totalActualAmount,
            })
        }
        setTableLoading(false);
    }

    useEffect(() => {
        fetchDataPayOuts().finally();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        tableParams?.sorter,
        tableParams?.search,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.filters)
    ]);

    return (
        <Page title="Pay out">
            <Space
                style={{
                    marginBottom: '20px'
                }}
            >
                <Button type={'primary'} className="custom-button export-button" icon={<ExportOutlined/>} onClick={() => setOpenExport(true)} title={'Xuất file'}>Xuất file</Button>
            </Space>
            <Search
                items={items}
                form={form}
                onSearch={handleSearch}
            />
            <Table
                rowKey={'uuid'}
                columns={columns}
                scroll={{
                    x: 2200,
                }}
                bordered={true}
                loading={tableLoading}
                dataSource={dataSource}
                pagination={tableParams.pagination}
                onChange={handleTableChange}
                summary={(data) => {
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={6}>
                                Thống kê
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} align={'center'} colSpan={1}>
                                <Tag color={'blue'}>{numberFormat(summaryData.totalAmount)}</Tag>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} align={'center'} colSpan={1}>
                                <Tag color={'blue'}>{numberFormat(summaryData.totalFee)}</Tag>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2} align={'center'} colSpan={1}>
                                <Tag color={'blue'}>{numberFormat(summaryData.totalActualAmount)}</Tag>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                    );
                }}
            />
            <ExportFile
                open={openExport}
                setOpen={setOpenExport}
                path={'/pay-out/exportFile'}
            />
        </Page>
    )
}

export default PayOut;
